import { createContext, useState } from "react";

export const ReportContext = createContext();

export const ReportProvider = ({ children }) => {
    const [selectedReport, setSelectedReport] = useState("Advance Metering Report");

    return (
        <ReportContext.Provider value={{ selectedReport, setSelectedReport }}>
            {children}
        </ReportContext.Provider>
    );
};
